<div class="card-support -title">
  <div class="-icon-container">
    <icon *ngIf="icon" [icon]="icon" [class]="iconsize + ' ' + iconcolor"></icon>
  </div>
  <div class="-content-container">
    <h3>{{title}}</h3>
    <ng-content></ng-content>
  </div>
</div>